import { render, staticRenderFns } from "./GroupDetailMemberEdit.vue?vue&type=template&id=f2ae2bec&scoped=true"
import script from "./GroupDetailMemberEdit.vue?vue&type=script&lang=js"
export * from "./GroupDetailMemberEdit.vue?vue&type=script&lang=js"
import style0 from "./GroupDetailMemberEdit.vue?vue&type=style&index=0&id=f2ae2bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ae2bec",
  null
  
)

export default component.exports